<mat-form-field class="dynamic-dropdown w-full" appearance="outline" [ngClass]="{'disabled': isDisabled}">
  <mat-label>{{labelInput}} *</mat-label>
  <mat-select #singleSelect (keydown)="_handleKeydown($event)" [required]="required"
    (selectionChange)="selectionChange.emit($event)" [formControl]="selectListControl"
    placeholder="{{ placeHolderInput }}" [compareWith]="compareOrganizations"
    panelClass="organization-selector-panel light">
    <mat-select-trigger>
      {{ selectListControl.value?.name || placeHolderInput }}
    </mat-select-trigger>
    @if (!userIsOrgAdminOrStudent) {
    <form [formGroup]="searchForm" class="w-full p-3">
      <mat-form-field
        class="servicemesh-mat-dense servicemesh-mat-no-subscript sticky top-0 z-9999 w-full bg-white px-1 pt-1">
        <input #searchSelectInput (keydown)="_handleKeydown($event)" matInput placeholder="Search"
          formControlName="searchBy" name="searchBy" [autocomplete]="'off'" />
        <mat-icon matPrefix>search</mat-icon>
        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearchAndFilter()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </form>
    } @if (isLoadingDropdown$()) {
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    }
    <!-- CURRENT (always at the top if selected) -->
    @if (currentItem) {
    <mat-option class="current-option" [value]="currentItem" [disabled]="!!(isLoadingDropdown$())">
      <div class="org-option">
        <div class="org-option__name">{{ currentItem?.name }}</div>
        <div class="org-option__meta">
          <span class="org-current">CURRENT</span>
        </div>
      </div>
    </mat-option>
    }

    <!-- Separator only if there are more options -->
    @if (currentItem && dataItemList?.length) {
    <mat-option class="options-separator-option" disabled>
      <div class="options-separator">
        <span>AVAILABLE OPTIONS</span>
      </div>
    </mat-option>
    }

    <!-- REST (without the current, even if it's on the page) -->
    @for (item of dataItemList; track trackByFn($index, item)) {
    <mat-option [value]="item" [disabled]="!!(isLoadingDropdown$())"
      (keydown)="stopInTemplatePropagationAndDefault($event)">
      <div class="org-option">
        <div class="org-option__name org-option__name--normal">{{ item?.name }}</div>
      </div>
    </mat-option>
    }
    <ng-container>
      @if (shouldShowOrganizationPaginator()) {
      <mat-paginator
        class="servicemesh-mat-dense servicemesh-mat-no-subscript w-50-p sticky bottom-0 z-9999 bg-white pt-1"
        [length]="pageInfo?.totalElements" [pageSizeOptions]="pageSizeOptions" [pageIndex]="pageInfo?.currentPage"
        [pageSize]="pageInfo?.pageSize" (page)="itemsPerPage($event)" [hidePageSize]="true" showFirstLastButtons
        [hidePageSize]="true">
      </mat-paginator>
      }
    </ng-container>
  </mat-select>
  @if (isPrivateRecord) {
  <mat-button matSuffix (click)="tooltipForClassification.toggle()" (keyup)="tooltipForClassification.toggle()">
    <mat-icon #tooltipForClassification="matTooltip" matTooltip="{{messagePrivateRecord}}"
      [matTooltipClass]="'bg-blue-900/90 text-md font-semibold'">info</mat-icon>
  </mat-button>
  }
</mat-form-field>